import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/** @jsx jsx */


import { jsx } from '@emotion/core';
import React, { useRef, useContext } from 'react';
import { withTheme } from 'emotion-theming';
import ImageSubstitution from '../ImageSubstitution';
import maxWidthMemo from '../maxWidthMemo';
import linkify from '../LinkHandlers';
import Svg from './svg';
import { StyledImage, inner, intrinsic, sizes } from './styles';
import { useLightbox, SectionLightboxContext } from '../Lightbox'; // Emotion 10 has hooks

var Img = withTheme(function Img(_ref) {
  var theme = _ref.theme,
      src = _ref.src,
      srcSet = _ref.srcSet,
      sizes = _ref.sizes,
      alt = _ref.alt,
      style = _ref.style,
      invert = _ref.invert,
      svgColor = _ref.svgColor,
      lightbox = _ref.lightbox,
      description = _ref.description;
  var sectionLightbox = useContext(SectionLightboxContext);
  var hasLightbox = typeof lightbox !== 'undefined' ? lightbox : sectionLightbox || false;
  var onClick = useLightbox(hasLightbox, {
    src: src,
    srcSet: srcSet,
    description: description || alt || ''
  });
  var themeColorKey = invert ? 'front2' : 'front1';
  var themeColor = theme.colors[themeColorKey];
  return jsx("img", {
    src: ImageSubstitution(src, svgColor || themeColor),
    sizes: sizes,
    srcSet: ImageSubstitution(srcSet),
    onClick: onClick,
    alt: alt,
    style: style
  });
});

var Component = function Component(props) {
  if (props.svg) {
    return React.createElement(Svg, props);
  }

  return React.createElement(Img, props);
};

function coord(x) {
  if (typeof x === 'number') {
    x += 'px';
  }

  if (x[0] === '-') {
    x = x.substring(1);
  } else {
    x = '-' + x;
  }

  return x;
}

export function Image(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      style = _ref2.style,
      position = _ref2.position,
      href = _ref2.href,
      target = _ref2.target,
      edit = _ref2.edit,
      _ref2$ratio = _ref2.ratio,
      ratio = _ref2$ratio === void 0 ? null : _ref2$ratio,
      rest = _objectWithoutPropertiesLoose(_ref2, ["children", "className", "style", "position", "href", "target", "edit", "ratio"]);

  var mergedStyle = style || {};

  if (position && (position.x || position.y)) {
    var _position$x = position.x,
        x = _position$x === void 0 ? 0 : _position$x,
        _position$y = position.y,
        y = _position$y === void 0 ? 0 : _position$y;
    mergedStyle = _objectSpread(_objectSpread({}, mergedStyle), {}, {
      objectPosition: coord(x) + " " + coord(y)
    });
  }

  var useHref = href && (process.env.ENV_RAW || !edit);
  var Anchor = useHref ? linkify({
    href: href,
    target: target
  }) : null;

  var _mergedStyle = mergedStyle,
      maxWidth = _mergedStyle.maxWidth,
      inlineStyles = _objectWithoutPropertiesLoose(_mergedStyle, ["maxWidth"]);

  var maxWidthStyle = maxWidthMemo(maxWidth);
  var comp = jsx(Component, Object.assign({}, rest, {
    style: inlineStyles
  }));

  if (process.env.ENV_RAW || !edit) {
    className = "image-box " + className;
  }

  var image = jsx(StyledImage, {
    className: className,
    style: maxWidthStyle,
    ratio: ratio,
    css: [ratio ? intrinsic : null, ratio ? sizes[ratio] : null]
  }, useHref ? jsx(Anchor.Component, Object.assign({
    css: ratio ? inner : null
  }, Anchor.props), comp) : ratio ? jsx("div", {
    css: inner
  }, comp) : comp);

  if (process.env.ENV_RAW || !edit) {
    return image;
  }

  return jsx("div", Object.assign({
    className: "image-box position-relative"
  }, process.env.ENV_RAW ? null : rest.uiEvents), image, children);
}